const Organizations = () => {
  return <h1>All Organizations</h1>;
};

export default Organizations;